import { apiSlice } from "../../../api/ApiService";
import { getHeadersFromRedux } from "../../../utility/functions/common-functions";
import { RewardWidgetResponse } from "../../../utility/interfaces/rewardActivityInterfaces";

const rewardWidgetApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getRewardWidget: builder.query<
      RewardWidgetResponse,
      { patientProfileId: number; patientPreferredLang: string }
    >({
      query: (patient: {
        patientProfileId: number;
        patientPreferredLang: string;
      }) => {
        const headers = getHeadersFromRedux();
        headers["X-Language"] = patient.patientPreferredLang;
        return {
          url: `/api/v1/Patient/${patient.patientProfileId}/reward-widget`,
          method: "GET",
          headers,
        };
      },
      providesTags: () => [{ type: "RewardWidget", id: "REWARDSWIDGET" }],
    }),
  }),
  overrideExisting: false,
});

export const { useGetRewardWidgetQuery } = rewardWidgetApi;
export default rewardWidgetApi;
